import React, { Component } from 'react';

export default class Placeholder extends Component {
	render() {
		return <div className="placeholder">Laden...</div>;
	}
}



// WEBPACK FOOTER //
// ./src/components/LazyLoad/Placeholder.jsx